import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./blade-runner-styles.scss";
import bladeRunnerLogo from "../../../../src/assets/blade-runner/logo-blade-runner.webp";

// NOTE: You said not to worry about images for now.
// If you later add Session 08 images, drop the imports in here and add <ImageComponent /> blocks back in.
import cover from "../../../../src/assets/blade-runner/session08/blade-runner-session-08-cover.webp";
import salon from "../../../../src/assets/blade-runner/session08/bright-eyes-beauty-salon.webp";
import esper from "../../../../src/assets/blade-runner/session08/esper-yukon-hotel.webp";
import lokTang from "../../../../src/assets/blade-runner/session08/lok_tang-cropped.webp";
import pamphlet from "../../../../src/assets/blade-runner/session08/wallace-pamphlet.webp";
import yukon from "../../../../src/assets/blade-runner/session08/yukon-hotel.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, 0.7) ",
  color: "white",
  marginBottom: "15px",
};

const BRSession08 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});
  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => {
    setShowModal("show");
  };
  const handleCloseModal = () => {
    setShowModal("", "");
  };

  // Helper for dialogue styling.
  // Assumes your SCSS defines .dialogue, .speaker, .line (or you can add them).
  // TODO: look into ths
  // <font style={{ fontStyle: "italic", color: "yellow" }}>

  // const Dialogue = ({ speaker, children }) => (
  //   <p className="dialogue">
  //     <span className="speaker">{speaker}</span>
  //     <span className="line">{children}</span>
  //   </p>
  // );

  const section1Data = [
    {
      title: "Crime Lab (Day 1, Shift 1 — Morning)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={cover}
            caption="Bright Eyes"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Blade Runner Session 08: Bright Eyes. Ellis Vale's corpse doesn't jive with his record and the trail
                  leads to the Yukon Hotel—where the a dead body, a feather, and
                  mysterious implications steer the investigation toward Bright
                  Eyes Beauty Salon."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <p>The Crime Lab smelled like antiseptic and regrets.</p>
          <p>
            Coco had Ellis Vale laid out under the lights. He underlined the
            hard truth: without a body under lab equipment, you can’t really
            tell who is who anymore— not in a world with Nexus-9s.
          </p>
          <p>
            Skinner tried to pull Ellis’ basic info on his KIA. The system
            fought him, then stalled. His anger and psychic disappointment did
            the rest. <i>(Resolve damage: Skinner -2.)</i>
          </p>
          <p>
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Coco. Has the blood under his fingernails been run yet?
            </font>
          </p>
          <p>
            Coco:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Not yet.
            </font>
          </p>
          <p>
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Coco, your locomotion is a little slow. Let’s test that.
            </font>
          </p>
          <p>
            Coco ignored the jab and ran the sample. The blood matched Ellis
            Vale’s Wallace DNA profile from his hire date six years ago.
          </p>
          <p>
            Combined with the corpse showing no muscular dystrophy and no
            smoker’s markers, Marion and Skinner started to suspect the worst: a
            replicant may have hurt or killed the real Ellis Vale to take his
            place at Wallace Corp—and gain access to the Memory Vaults.
          </p>
          <p>Skinner jotted the questions they’d need for Quell at Wallace:</p>
          <ol>
            <li>Who else could be replicants?</li>
            <li>Whose offices—and what areas—could “Ellis” access?</li>
            <li>
              What does it take to make a replicant? How big a facility? What
              materials? What kind of operation?
            </li>
          </ol>
          <p>
            Priority shifted fast. Ellis’ last known address was the Yukon
            Hotel. Marion and Skinner moved to check it before the trail cooled.
          </p>
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "Yukon Hotel (Day 1, Shift 2 — Afternoon)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={yukon}
            caption="Yukon Hotel"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="The Yukon is a dingy hotel in Sector 5. It was in bad shape already in 2019, when Nexus-6 Replicant Leon Kowalski stayed here before being retired by Blade Runner Rick Deckard (according to the official story). Now, it’s even worse – the old building, once beautiful, is now a dilapidated husk, catering only to those who can’t afford anything else"
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <p>
            Marion and Skinner traveled to the Yukon Hotel in separate spinners.
            In the lobby, an elderly Asiatic man sat behind a makeshift safety
            cage: Lok Tang, the ever-present proprietor of the flophouse.
          </p>

          <p>
            Marion flashed his LAPD Rep-Detect badge. Lok Tang said Ellis had
            visitors the night before— five or six people. One was a woman,
            mid-to-late 40s with dark hair, carrying a large bird perched on her
            arm.
          </p>

          <p>
            Lok Tang:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Synthetic for sure, right? No one with real money be coming around
              here.
            </font>
          </p>

          <p>
            Lok Tang opened Ellis’ room and retreated. The detectives stepped
            into the shabby, threadbare box. First thing they saw: a dead body
            on the floor. And blood. Lots of it.
          </p>

          <p>
            Before they moved further, Skinner saw today’s Independent Sentinel
            on the floor ad picked it up:
            <b> Tuesday, June 9, 2037</b>.
          </p>

          <p>Skinner scanned the headlines:</p>
          <ul>
            <li>
              Holden quoted on the first-year anniversary of Nexus-9s since the
              UN repealed the Prohibition.
            </li>
            <li>
              Wallace warning about bootleg replicants.{" "}
              <i>“Wasted no time there,”</i> Skinner muttered.
            </li>
            <li>No suspects in the murder of Lilith Tyrell.</li>
            <li>
              Rep-Detect raids near the Sepulveda Sea Wall—rumored haven for
              Underground sympathizers looking for a boat out of the city.
            </li>
          </ul>

          <p>
            Skinner called Ray McCoy from the room while Marion held position,
            waiting to sweep the scene together.
          </p>

          <p>
            McCoy:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              McCoy here.
            </font>
          </p>
          <p>
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              I’m looking at this article about the Sepulveda Sea Wall. On top
              of the shakedowns and raids, I want you to see if there’s
              anything—an old factory, someplace a crew building bootleg
              replicants could operate.
            </font>
          </p>
          <p>
            McCoy:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Interesting. I know some Joes on detail at the wall. I can make
              calls, pull a favor—get extended drone coverage. Maybe have the
              guys look closer at manifests coming into port.
            </font>
          </p>
          <p>
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Well Ray, you’re the real McCoy, you know that?
            </font>
          </p>
          <p>
            McCoy:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              The one and only. I’ll call you. And you still owe me a drink at
              the Overlook.
            </font>
          </p>

          <p>
            While Skinner talked, Marion noticed the Sentinel’s lower-left
            corner was torn off—specifically the part with an ad for{" "}
            <b>Bright Eyes Beauty Salon</b>.
          </p>
          <p>
            Marion:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Look. Someone tore off the ad. Another place we should check out.
            </font>
          </p>
          <p>
            Marion took a swig from his hip flask to fortify his resolve. The
            gin burned. It helped.
          </p>

          <p>
            Skinner took the Sentinel back and recovered a point of resolve
            using his Origami specialty. He folded the paper so Holden’s face
            became the body of an origami stick figure and left it on the
            bureau.
          </p>

          <p>
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Something for forensics to laugh about. Alright. Let’s see what we
              got here.
            </font>
          </p>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={pamphlet}
            caption="Wallace Corporation"
            cssClass="imageRight"
            handleClick={handleClick}
            modalBody="Wallace Corporation pamphlet."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <p>The detectives find:</p>
          <ul>
            <li>A standard Wallace Corporation pamphlet on the nightstand.</li>
            <li>
              A large feather on the floor.{" "}
              <font style={{ fontStyle: "italic", color: "yellow" }}>
                “Probably from that woman with the bird”
              </font>
              , Skinner muttered.
            </li>
            <li>And oh yeah, that dead body.</li>
          </ul>

          <p>
            The cause of death was obvious: crushed skull, both eyes gouged out.
            Skinner’s mind flashed to Roy Batty squeezing out Eldon Tyrell's
            eyes; son murdering father in November 2019—an LAPD truth the public
            never got in full.
          </p>

          <p>
            Even with the damage, it was clear: this corpse was Ellis Vale. The
            real Ellis—small legs from dystrophy, yellowed fingertips from a
            lifetime of smoking.
          </p>

          <p>
            Skinner calls LAPD forensics so they can confirm the obvious and
            bring in Sunshine Cleaning for the mess.
          </p>

          <p>
            On the way out, Marion shows Lok Tang a picture of Lilith Tyrell.
          </p>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={lokTang}
            caption="Lok Tang"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="As the manager of the Yukon Hotel for over 20 years, Lok Tang has seen more than his fair share of seedy activities. He prefers to stay out of his guests’ business but is not willing to antagonize the LAPD to protect their privacy."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <p>
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Was this the lady you saw?
            </font>
          </p>
          <p>
            Lok Tang:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Oh yeah. That her for sure.
            </font>
          </p>

          <p>
            Lok Tang leaned in close and gestured for Skinner to lean in. Then
            he gestured for closer still, almost like two lovers sharing a
            secret.
          </p>

          <p>
            Lok Tang:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              I thought you looked familiar. I saw you with them.
            </font>
          </p>
          <p>
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              What? Where have you seen me?
            </font>
          </p>

          <p>
            Lok Tang disengaged and tried to play it off—loudly claiming he was
            mistaken.
          </p>
          <p>Marion didn’t buy it.</p>

          <p>
            Marion:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              I don’t trust this guy, Skinner. Let’s take him downtown.
            </font>
          </p>

          <p>That broke Lok Tang’s composure.</p>
          <p>
            Lok Tang:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              I saw you, Skinner—you came in with the lady and the others. Maybe
              you undercover. I don’t know. Not my business. I didn’t see
              anything… especially for chinyen.
            </font>
          </p>
          <p>Marion gives Lok Tang a hard mean mug.</p>
          <p>
            Lok Tang:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              Or—just not to go downtown. I trust you. I say nothing. I know
              nothing.
            </font>
          </p>

          <p>
            Skinner turned to Marion, rain swallowing the doorway as Reardon and
            backup arrived.
          </p>

          <p>
            Skinner:{" "}
            <font style={{ fontStyle: "italic", color: "yellow" }}>
              That body is the real Ellis—replaced by a replicant that broke
              into Wallace Memory Vaults. Now we gotta face the possibility
              there may be a replicant version of me roaming around out there.
            </font>
          </p>

          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "LAPD Mainframe & Esper Wall (Day 1, Shift 3 — Evening)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={esper}
            caption="Esper Wall"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Esper footage shows replicat Ellis and frieds arriving at Yukon Hotel the night before Ellis is arrested for breaking into Wallace Corporation Memory Vaults."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <p>
            They split up. Marion heads to LAPD to work the mainframe and the
            Esper Wall; Skinner toward Bright Eyes Beauty Salon.
          </p>

          <p>
            Marion takes another swig of gin to steady himself. The clear fire
            burned going down. He smacked his lips. This could become a habit.
          </p>

          <p>
            First he ran queries about Sepulveda Sea Wall activity—nothing
            besides standard patrol reports and ad-hoc check-ins from undercover
            stevedores trying to infiltrate the rumored Underground presence at
            the docks.
          </p>

          <p>
            Then he pulled Esper footage from the Yukon. Sure enough: six people
            entering the hotel, including a woman with a large bird. The
            lighting was terrible and the cameras worse. He could only ID Ellis
            Vale; the stronger, replicant Ellis.
          </p>

          <p>
            Marion calls Skinner and asks for a picture of the feather. Skinner
            sends it and asks Marion to look for any facial recognition hits,
            GPS traces, or sightings tied to Skinner himself.
          </p>

          <p>
            Marion finds one anomalous data point: Skinner’s KIA pinged
            downtown—somewhere Skinner hadn’t been in months—for about a
            quarter-second before self-correcting. A failed remote hack? A
            routing glitch? Hard to say.
          </p>

          <p>
            Marion feeds the feather into the system. It has a serial number—but
            the number didn’t exist in current records system. Esper AI suggests
            the serial may have been generated before the Blackout of 2022.
          </p>

          <p>
            The thought pulled Skinner and Marion into the long shadow of the
            Blackout—an event that made distrust of technology feel less like
            paranoia and more like survival.
          </p>
          <p>
            <font
              style={{
                fontStyle: "italic",
                color: "cornflowerblue",
                fontSize: "0.7em",
                fontFamily: "monospace",
              }}
            >
              <h4>The Blackout of 2022</h4>
              <p>
                As riots threatened to sweep through the colonies, everything
                went dark: in **May 2022**, unidentified terrorists detonated an
                **EMP in the LA stratosphere**, plunging the **West Coast** into
                blackout. Powerless **spinners, blimps, and other aircraft**
                crashed into streets and buildings, and for **ten days**
                machines failed—**communications down**, cities “deaf and
                blind.”
              </p>
              <p>
                When power returned, people discovered the **worldwide datalink
                had been erased**. During the outage, attackers destroyed
                **secure data centers** and the **digital and magnetic backups**
                of the storage cloud—wiping **bank accounts, medical records,
                libraries, and personal photos**. Markets collapsed,
                infrastructure failed, and no one claimed responsibility for
                what became known as **the Blackout**. Because the attack also
                erased the **Replicant Registration Database**, making **Nexus
                models untraceable**, **Replicants were widely blamed**.
              </p>
              <p>
                The aftermath reshaped society:
                <br />
                distrust of digital systems drove a shift toward **reliable
                analog tech**; major Earth-based corporations moved
                **off-world**, shrinking jobs and the economy; and **air
                travel** became rare, largely limited to authorized government
                use. Most critically, the UN imposed an **indefinite Prohibition
                on Replicant technology**, expanding **Rep-Detect/Blade Runner**
                “Retirement” efforts to target **all Replicants**, not just
                violent **Nexus-6**—forcing even compliant **Nexus-8s** to run.
                Tyrell fell into **infamy and bankruptcy**, the **Underground**
                collapsed under a UN task force, remaining N-8s vanished or
                died, and the last Nexus-6s **aged out their four-year
                lifespans**—ending humanity’s great innovation era on a grim
                note.
              </p>
            </font>
          </p>
          <p>
            Out of that reverie came a practical conclusion: if the feather was
            pre-Blackout, the only place still dealing in synthetic animals that
            old was <b>Runciter’s Zoological</b> on Animoid Row.
          </p>

          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },

    {
      title: "Bright Eyes Beauty Salon (Nightfall)",
      text: (
        <div className="bladeRunnerFont bladeRunnerTitleText">
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>

          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={salon}
            caption="Bright Eyes Salon"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Bright Eyes Beauty Salon: Just one of the countless tiny beauty parlors in Sector 1, Bright Eyes doesn’t stand out, offering the same range of stereoscopic tattoos and other cosmetic augmentations as many other"
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <p>
            Skinner landed his spinner and walked a few blocks, moving through
            the crowds under neon umbrellas—fog of exhaust, breathing, and food
            fumes swirling together in the rain.
          </p>

          <p>
            Bright Eyes glowed half a block ahead. Skinner focused on the
            destination, snapping himself back to the now.
          </p>

          <p>Then he saw it.</p>

          <p>
            A man broke from the sidewalk flow and opened the salon door. Long
            hair. Beard. Shabby blazer and random tee.
          </p>

          <p>It was him.</p>

          <p>Skinner watched himself step inside Bright Eyes Beauty Salon.</p>

          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/blade-runner/background-blade-runner-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "Orbitron",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a name="pageTop" href="#pageTop">
                  <img
                    src={bladeRunnerLogo}
                    style={{
                      maxWidth: "400px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                    alt="Blade Runner campaign"
                  />
                </a>
              </main>

              <h1 className="cover-heading">BRIGHT EYES</h1>
              <small>Blade Runner Session 08</small>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title
                id="cardTitle-blade-runner"
                className="cardTitle-blade-runner"
              >
                <span
                  style={{
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  Ellis Vale's corpse doesn't jive with his record and the trail
                  leads to the Yukon Hotel—where the a dead body, a feather, and
                  mysterious implications steer the investigation toward Bright
                  Eyes Beauty Salon.
                </span>
                <br />
                <font
                  style={{
                    color: "#C21E56",
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  WARNING: SPOILERS for Fiery Angels case file.{" "}
                </font>
                <br />
                <small>
                  ⇐ Session 07:{" "}
                  <a href="./blade-runner-session-07">The Leash</a> ☠ Session
                  09: <a href="./blade-runner-session-09">Neon Mirror</a> ⇒{" "}
                </small>
              </Card.Title>

              <div>
                <ContentContainer data={section1Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BRSession08;
